import apiService from 'src/shared/config/apiService';
import handleAxiosError from 'src/shared/utils/handleAxiosError';

export type UpdateSamplingPayload = {
  name: string;
  id: string;
  productId: string;
};
type UpdateSamplingResponse = any;

export const updateSampling = async (
  payload: UpdateSamplingPayload
): Promise<UpdateSamplingResponse> => {
  try {
    const { data } = await apiService.patch<UpdateSamplingResponse>(
      `/products/${payload.productId}/samples/${payload.id}`,
      {
        name: payload.name
      }
    );

    return data;
  } catch (error) {
    throw handleAxiosError(error);
  }
};
